import LookupDetail from '@/models/Lookup/LookupDetail';

export default class LookupDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.name = '';
		this.lookupId  = '';
		this.lookupName = '';
		this.value = '';
		this.isEditable = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			name : '0',
			lookupId : '0',
			lookupName : '0',
			value : '0',
			isEditable : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}